import { FC } from "react";

import { NotificationCreatePage } from "./presentations";

export const NotificationCreatePageContainer: FC<
  React.PropsWithChildren<React.PropsWithChildren<unknown>>
> = () => {
  return <NotificationCreatePage />;
};
